module.exports = __webpack_public_path__ + "static/media/payment_success.948eb1b9.png";